export const validation = {
  maxTitleCount: 120,
  maxParagraph: 1000
}
